function removeTargetFromInternalLinks() {
  // Add links here to remove them
  var links = ["https://gatheringgames.co.uk/community/blog"];

  for (var i = 0; i < links.length; i++) {
    /*document
      .querySelectorAll("a[href^='" + links[i] + "']")
      .removeAttribute("target");*/

     document.querySelectorAll("a[href^='" + links[i] + "']").forEach( e => {
        e.target == '_blank' && e.removeAttribute('target');
    });
  }
}

// Call it
removeTargetFromInternalLinks();